import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ChartConfiguration, ChartData } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { AnalyticsResultsService, TransactionCategoryGroupStatistic } from 'src/app/shared/services/analytics-results.service';

@Component({
  selector: 'app-txn-cat-groups-over-time-bar-chart',
  templateUrl: './txn-cat-groups-over-time-bar-chart.component.html',
  styleUrls: ['../widgets.scss', './txn-cat-groups-over-time-bar-chart.component.scss']
})
export class TxnCatGroupsOverTimeBarChartComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  constructor(private resultsAnalyticsSvc: AnalyticsResultsService, private breakpointObserver: BreakpointObserver) {
    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      if (result.matches) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });
  }

  currentYearTxnCatGroups: TransactionCategoryGroupStatistic[] = new Array<TransactionCategoryGroupStatistic>();
  isMobile: boolean = false;

  chartPlugins = [];

  chartOptions: ChartConfiguration['options'] = {
    // We use these empty structures as placeholders for dynamic theming.
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 2,
    scales: {
      x: {
        grid: {
          display: false
        }
      },
      y: {
        beginAtZero: true,
        display: false,
        grid: {
          display: false
        },
        ticks: {
          display: false
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        // position: "bottom",
        labels: {
          boxWidth: 10
        }
      },
      tooltip: {
        callbacks: {
          label: (item) =>
            `${item.dataset.label}: $${item.formattedValue}`
        }
      }
    },
  };

  chartData: ChartData<'bar'> = {
    datasets: []
  };

  ngOnInit(): void {
    this.resultsAnalyticsSvc.getCategoryGroupsForTransactionsCurrentYear()
      .subscribe({
        next: (data) => {
          this.currentYearTxnCatGroups = data;
          this.buildCategoryGroupByMonthData();
        },
        error: (err: HttpErrorResponse) => {
          if (err.status == 400) {
          } else {
            throw err;
          }
        }
      });
  }

  buildCategoryGroupByMonthData() {
    if (this.currentYearTxnCatGroups && this.currentYearTxnCatGroups.length > 0) {
      let labels: string[] = new Array<string>();
      let datasets: string[] = new Array<string>();
      let data: Map<string, number[]> = new Map();

      let processingChartData: ChartData<'bar'> = {
        datasets: []
      }

      this.currentYearTxnCatGroups.forEach((x) => {
        if (!labels.includes(x.dim_txndate_yearmonthname)) {
          labels.push(x.dim_txndate_yearmonthname);
        }

        if (!datasets.includes(x.dim_txncatgrp)) {
          datasets.push(x.dim_txncatgrp);
        }
      });

      datasets.forEach((x) => {
        data.set(x, new Array<number>(labels.length).fill(0));
      });

      this.currentYearTxnCatGroups.forEach((x) => {

        let labelIndex = labels.indexOf(x.dim_txndate_yearmonthname);

        if (data.get(x.dim_txncatgrp) != undefined) {
          (data.get(x.dim_txncatgrp) as number[])[labelIndex] = x.fct_sum_abs_amount as number;
        }
      });

      let itemsToRemove = 0;

      if (labels.length > 6) {
        itemsToRemove = labels.length - 6;
      }

      if (this.isMobile) {
        itemsToRemove = labels.length - 3;
      }

      labels.splice(0, itemsToRemove);

      data.forEach((val, key) => {
        val.splice(0, itemsToRemove);
      });

      processingChartData.labels = labels;
      data.forEach((val, key) => {
        processingChartData.datasets.push({
          data: val,
          label: key
        });
      });
      console.log(processingChartData);

      this.chartData = processingChartData;

      this.chart?.update();
    }
  }
}
